export const ProductData = {
    data() {
        return {}
    },
    methods: {
        // 商品品牌列表
        GetBrandData(obj) {
            return new Promise((resolve, reject) => {
                this.$request({
                    url: '/api/v1/brand',
                    params:
                        obj && obj.data
                            ? {
                                  ...obj.data
                              }
                            : null
                })
                    .then(res => {
                        if (!res.status) {
                            resolve(res.data)
                        } else {
                            this.$message.error(res.message || '操作失败')
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // 商品分类列表
        GetClassifyData(obj) {
            return new Promise((resolve, reject) => {
                this.$request({
                    url: '/api/v1/classify',
                    params:
                        obj && obj.data
                            ? {
                                  ...obj.data
                              }
                            : null
                })
                    .then(res => {
                        if (!res.status) {
                            resolve(res.data)
                        } else {
                            this.$message.error(res.message || '操作失败')
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // 商品单位列表
        GetUnitData(obj) {
            return new Promise((resolve, reject) => {
                this.$request({
                    url: '/api/v1/unit',
                    params:
                        obj && obj.data
                            ? {
                                  ...obj.data
                              }
                            : null
                })
                    .then(res => {
                        if (!res.status) {
                            resolve(res.data)
                        } else {
                            this.$message.error(res.message || '操作失败')
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }
    }
}
